import { STATE_LIST } from '@vangst/lib/constants/locations'
import stateSlugToAbbreviation from '@vangst/lib/stateSlugToAbbreviation'
import unionizeAll from '@vangst/lib/unionizeAll'
import { StatesEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { useRouter } from 'next/router'
import SelectState from '../application/forms/SelectState'

function stateSlug({ state }: { state: StatesEnum }) {
  const stringified = unionizeAll(state.toLowerCase(), '-')
  return Routes.REPORTS_STATE_REQUIREMENTS_DETAIL.replace(':slug', stringified)
}

function StateRequirementsHeaderSelect() {
  const { push, query } = useRouter()
  const handleChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
    if (e?.currentTarget?.value === '') {
      push(Routes.REPORTS_STATE_REQUIREMENTS)
      return
    }
    const state = STATE_LIST[e?.currentTarget?.value as keyof typeof STATE_LIST]
    push(stateSlug({ state: state as StatesEnum }))
  }
  const defaultValue =
    query?.slug != null
      ? stateSlugToAbbreviation(String(query.slug))
      : undefined

  return (
    <div id="state-details" className="mood-orange">
      <div className="contain-xc grid justify-center gap-4 py-16">
        <span className="text-center text-md sm:heading-md">
          How to get licensed or badged to work in the cannabis industry in your
          state:
        </span>
        <div className="flex w-3/4 justify-self-center sm:w-5/10">
          <SelectState
            className="text-black"
            defaultValue={defaultValue ?? ''}
            onChange={(e: React.SyntheticEvent<HTMLSelectElement>) =>
              handleChange(e)
            }
            name="select-state"
            label="Select A State"
            hideLabel
          />
        </div>
      </div>
    </div>
  )
}

export default StateRequirementsHeaderSelect
